import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './SessionsSkeleton.module.css';

export function SessionsSkeleton() {
  return (
    <div className={skeletonStyles.container} data-testid="sessions-skeleton">
      {/* Segmented toggle skeleton — single bar matching SegmentedToggle shape */}
      <div className={skeletonStyles.tabsSkeleton}>
        <Skeleton width={300} height={40} borderRadius="var(--radius-md)" />
      </div>

      {/* Sections Skeleton */}
      <div className={skeletonStyles.sectionsList}>
        {[1, 2].map((section) => (
          <div key={section}>
            <Skeleton width={150} height={24} style={{ marginBottom: 'var(--spacing-4)' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-4)' }}>
              {[1, 2, 3].map((card) => (
                <div key={card} className={skeletonStyles.card}>
                  <div className={skeletonStyles.cardInfo}>
                    <Skeleton width="40%" height={20} />
                    <Skeleton width="20%" height={16} />
                  </div>
                  <div className={skeletonStyles.cardActions}>
                    <Skeleton width={80} height={36} />
                    <Skeleton width={32} height={32} variant="circular" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
